import React, { useEffect } from "react";
import { Element } from "react-scroll";
import AOS from "aos";
import "aos/dist/aos.css";
import "./index.css";
import Navbar from "./components/Navbar";
import About from "./components/About";
import Skills from "./components/Skills";
import Certifications from "./components/Certifications";
import Projects from "./components/Projects";
import Explorations from "./components/Explorations";
import Testimonials from "./components/Testimonials";
import Profiles from "./components/Profiles";

export default function App() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <Navbar />
      <Element name="about">
        <About />
      </Element>
      <Element name="skills">
        <Skills />
      </Element>
      <Element name="certifications">
        <Certifications />
      </Element>
      <Element name="projects">
        <Projects />
      </Element>
      <Element name="explorations">
        <Explorations />
      </Element>
      <Element name="testimonials">
        <Testimonials />
      </Element>
      <Element name="profiles">
        <Profiles />
      </Element>
    </div>
  );
}
